module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/zawieszenie@2x-9741ac06.png";